import React, { Suspense } from 'react';
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,

  prepareFilter,
  filterFields,
  filterInitialValues,
} from './ProvinceUtils';




const ProvincePage = () => {

  const { currentState } = useSelector(
    (state) => ({ currentState: state.provinces }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/provinces")) {
    const temp = menuList.find(q => q.url == "/provinces")
    isFullAccess = temp.isFullAccess;
  }

  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {
            <Redirect
              exact={true}
              from="/provinces"
              to="/provinces/provinces"
            />

          }
          {
            <Redirect
              // exact={true}
              from="/provinces/towns"
              to="/provinces/provinces"
            />

          }

          <ContentRoute path="/provinces/provinces/new"
            render={props =>
              <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/provinces/provinces" api="api/province" currentState={currentState} initObject={initObject}
                formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
          />

          <ContentRoute
            path="/provinces/provinces/:id/edit"
            render={props =>
              <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/provinces/provinces" api="api/province" currentState={currentState} initObject={initObject}
                formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
          />

          <ContentRoute
            path="/provinces/provinces"
            render={props => <ObjectsPage isFullAccess={isFullAccess} basePath="/provinces/provinces" api="api/province" currentState={currentState}
              columns={columns} prepareFilter={prepareFilter} filterFields={filterFields} filterInitialValues={filterInitialValues} />}
          />

        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  )
}

export default ProvincePage



